import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        stroke="#FFF"
        strokeLinejoin="round"
        strokeWidth={3}
        d="m61.389 25.33-1.496 5.25c-.27.474-.438.914-.438 1.333 0 .296.098.57.276.826.063.091.597-.246.807-.238l1.868.068-.47 1.809q-2.773 10.653-4.07 14.587c-.275.825-.507 1.573-.716 2.246-.923 2.974-1.66 4.57-2.924 5.295-1.15.659-2.845.733-6.04-.238q-1.775-.54-9.131-2.652l15.15-27.03 7.184-1.257Z"
      />
      <g strokeLinejoin="round">
        <path
          fill="#F5F3F0"
          stroke="#FFF"
          strokeWidth={3}
          d="M12.658 5.107a2.45 2.45 0 0 1 1.816-.328l42.735 12.326c.65.188 1.163.621 1.466 1.17.307.557.4 1.233.2 1.892L47.3 55.838 10.72 45.674a9.83 9.83 0 0 1-5.944-4.649 9.83 9.83 0 0 1-.914-7.497l7.752-27.027c.173-.6.555-1.084 1.044-1.394Z"
        />
        <path
          stroke="#000"
          strokeWidth={2}
          d="M12.926 5.53c.412-.262.92-.367 1.428-.265l42.717 12.32c.517.15.925.495 1.166.932.244.442.318.978.161 1.501l-11.425 35.21-36.119-10.035a9.33 9.33 0 0 1-5.643-4.414 9.34 9.34 0 0 1-.867-7.119l7.75-27.021c.138-.478.442-.863.832-1.11Z"
        />
      </g>
      <path
        fill="#000"
        fillRule="nonzero"
        d="M11.61 25.96q-.89-.255-.63-1.16l2.23-7.78q.26-.904 1.15-.649l.192.055q.684.197.913.9l2.215 7.01 1.599-5.576q.259-.904 1.163-.645.89.255.631 1.16l-2.23 7.78q-.26.904-1.11.66l-.15-.043q-.713-.203-.913-.899l-2.248-7.256-1.662 5.794q-.26.905-1.15.649m10.074 2.888q-.903-.258-.644-1.163l2.23-7.78q.26-.905 1.164-.645l4.726 1.355q.903.26.668 1.081-.235.822-1.14.563l-3.849-1.104-.64 2.233 3.438.986q.905.26.669 1.08-.237.823-1.14.563l-3.438-.985-.696 2.424 4 1.147q.905.26.669 1.081-.236.822-1.14.563zm9.732 2.791q-.822-.235-.759-1.077l.554-8.291q.042-.507.3-.708.256-.2.682-.078.48.137.686.397t.15.717l-.544 5.878 3.031-5.194q.43-.721 1.21-.498.781.224.763 1.063l-.182 6.011 2.653-5.272q.37-.77 1.205-.53.48.138.624.461t-.103.771l-3.92 7.311q-.392.747-1.227.508-.809-.232-.79-1.072l.188-6.498-3.284 5.61q-.43.723-1.237.49Zm13.055 3.966a5.2 5.2 0 0 1-1.813-.913q-.787-.618-1.17-1.662-.154-.444.026-.734t.608-.389q.416-.103.684.07.27.174.466.571.232.482.651.832t1.104.546q.945.27 1.352.04.408-.232.56-.766.099-.343.012-.635-.086-.291-.55-.668-.462-.378-1.483-.952-1.239-.697-1.668-1.576-.43-.879-.131-1.92.248-.862.843-1.389.595-.525 1.446-.675.85-.149 1.864.142 1.068.307 1.746.916.678.61 1.02 1.33.18.407.019.71-.161.301-.578.464-.417.162-.701.014-.284-.149-.499-.536a2.8 2.8 0 0 0-.567-.711q-.352-.324-.954-.496-.644-.184-1.125-.034-.48.152-.642.713a1 1 0 0 0-.01.479q.051.259.42.602.367.343 1.247.847 1.493.843 1.993 1.81.501.966.183 2.075-.405 1.412-1.57 1.885t-2.783.01"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={2}
        d="M23.762 48.79q18.483 5.273 23.47 6.654c3.936 1.09 7.161 3.03 9.122-3.396Q58.557 44.83 61.512 34m-8.851 16.674 7.432-23.455"
      />
      <path
        stroke="#007BBD"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M15.553 10.753 42.5 18.5M17.394 32.867l25.993 7.453m-27.255-3.348 26.187 7.51"
      />
      <rect
        width={6}
        height={6}
        x={8}
        y={30}
        fill="#F48E22"
        rx={1}
        transform="rotate(16 11 33)"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
